import {AbstractHttpRequestObserver} from "@/services/observer/common/AbstractHttpRequestObserver";
import {app} from "@/app";

export class AddToCart extends AbstractHttpRequestObserver
{
    isApplicable(method: string, url: string): boolean
    {
        return (
            method === "POST" &&
            url.indexOf("/cart/add.js") != -1
        );
    }

    resolve(method: string, url: string, responseSource: string, response: Record<string, any> | null)
    {
        if(!response) return;

        let items: any[]|null = null;

        /*
         * NOTE: fetch and ajax reqests seems to result in different response structure:
         *  - fetch: `items:[{item}]`
         *  - ajax : `{item}`
         */

        if('items' in response) {
          items = response.items;
        }

        if(items === null && 'variant_id' in response) {
          items = [response];
        }

        app.pixel.events.shopify.addToCart.handle({items});
    }
}
